import { 
  MY_TASK_PROCESS_LOADING,
  ADD_MY_TASK_LIST,
  ADD_MY_TASK_LIST_FAILED,
  GET_MY_TASK_LIST, 
  UPDATE_MY_TASK_LIST,
  DELETE_MY_TASK_LIST,
  DELETE_MY_TASK_LIST_FAILED,
  GET_MY_TASK_LIST_DETAIL
} from "../actions";

const initialState = {
  taskList: [],
  isSuccess: false,
};

const learningMyTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case MY_TASK_PROCESS_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_MY_TASK_LIST:
      return {
        ...state,
        taskList: action.payload,
      };
    case ADD_MY_TASK_LIST:
      return {
        ...state,
        isSuccess: true,
      };
    case ADD_MY_TASK_LIST_FAILED:
      return {
        ...state,
        isSuccess: false,
      };
    case UPDATE_MY_TASK_LIST:
      return {
        ...state,
      };
    case DELETE_MY_TASK_LIST:
      return {
        ...state,
        isSuccess: true,
      };
    case DELETE_MY_TASK_LIST_FAILED:
      return {
        ...state,
        isSuccess: false,
      };
    default:
      return state;
  }
};

export default learningMyTaskReducer;
